import { useCoveoHeadless } from './../recommandations';
import { buildPopularViewedRecommendationsList, PopularViewedRecommendationsList } from '@coveo/headless/product-recommendation';

const useCoveoHeadlessPopularViewedProductRecommendation = (options) => {
  const { productRecommendationsList, engine } = useCoveoHeadless<PopularViewedRecommendationsList>(options, buildPopularViewedRecommendationsList);

  return {
    popularViewedRecommendationsList: productRecommendationsList,
    engine
  };
}

export default useCoveoHeadlessPopularViewedProductRecommendation;
